var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSalvSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 1760 1600"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "salv_small_svg__a",
  d: "M0 0h1760v1600H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "salv_small_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#salv_small_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1139.141 1600h-293.49c-88.39 0-160.05-71.63-160.05-160s71.66-160 160.05-160h293.49c117.79 0 218.87-61.14 270.36-163.55 48.87-97.18 39.03-207.65-26.28-295.51l-299.01-402.18-801.08 963.52c-56.51 67.94-157.41 77.25-225.39 20.77-67.97-56.49-77.27-157.37-20.77-225.33l931.18-1120c31.39-37.73 78.07-59.03 127.44-57.66a160.06 160.06 0 0 1 124.09 64.49l420.44 565.49c136.95 184.22 158.17 425.67 55.36 630.14-105.4 209.61-318.58 339.82-556.34 339.82",
  mask: "url(#salv_small_svg__b)"
}))));
export default SvgSalvSmall;